<!-- When closed, inert keeps focus from entering off-canvas menu (still visible to AT when open). -->
<div class="side-menu-root" [attr.inert]="!isOpen ? '' : null" [class]="direction">
  <div
    class="sidebar-overlay"
    [class.open]="isOpen"
    [attr.aria-hidden]="!isOpen ? 'true' : null"
    (click)="onClose()"
  ></div>
  <div
    class="sidebar"
    [class.open]="isOpen"
    [attr.aria-hidden]="!isOpen ? 'true' : null"
    >
    <!-- Header -->
    <div class="sidebar-header">
      <div class="header-content">
        <!--
          a11y: main sidebar back/close button.
          - `#closeBtn` template ref so the component can focus it the
            instant `isOpen` flips to true (audit: focus must jump here
            on hamburger click).
          - aria-label is `closeMenuText` ("סגירת תפריט"), not the generic
            `closeText` ("סגור") — per audit the SR must announce this
            specifically as "Close menu".
        -->
        <button
          #closeBtn
          type="button"
          class="close-btn"
          (click)="onClose()"
          [attr.aria-label]="closeMenuText">
          <ng-icon [name]="direction === 'rtl' ? 'chevron-right' : 'chevron-left'" class="text-xl" aria-hidden="true" />
          <span class="menu-text" aria-hidden="true">{{ menuText }}</span>
        </button>
      <div class="language-selector">
        <svg class="globe-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
          <path d="M11 8C11 8.71875 10.9062 9.375 10.7812 10H5.1875C5.0625 9.375 5 8.71875 5 8C5 7.3125 5.0625 6.65625 5.1875 6H10.7812C10.9062 6.65625 11 7.3125 11 8ZM11.8125 6H15.7188C15.9062 6.65625 16 7.3125 16 8C16 8.71875 15.9062 9.375 15.7188 10H11.8125C11.9375 9.375 12 8.71875 12 8C12 7.3125 11.9375 6.65625 11.8125 6ZM15.4062 5H11.5938C11.0625 2.96875 10.0938 1.25 9.28125 0.125C12.0625 0.5625 14.375 2.46875 15.4062 5ZM10.5625 5H5.40625C5.78125 3.75 6.3125 2.65625 6.84375 1.71875C7.25 1.03125 7.65625 0.46875 8 0.0625C8.3125 0.46875 8.71875 1.03125 9.125 1.71875C9.65625 2.625 10.2188 3.75 10.5625 5ZM4.375 5H0.5625C1.59375 2.46875 3.90625 0.5625 6.6875 0.125C5.875 1.25 4.90625 2.96875 4.375 5ZM0.25 6H4.15625C4.0625 6.65625 4 7.3125 4 8C4 8.71875 4.0625 9.375 4.15625 10H0.25C0.0625 9.375 0 8.71875 0 8C0 7.3125 0.0625 6.65625 0.25 6ZM5.40625 11H10.5625C10.1875 12.2812 9.65625 13.375 9.125 14.3125C8.71875 15 8.3125 15.5625 8 15.9688C7.65625 15.5625 7.25 15 6.84375 14.3125C6.3125 13.375 5.78125 12.2812 5.40625 11ZM4.375 11C4.90625 13.0625 5.875 14.75 6.6875 15.9062C3.90625 15.4688 1.59375 13.5625 0.5625 11H4.375ZM15.4062 11C14.375 13.5625 12.0625 15.4688 9.28125 15.9062C10.0938 14.75 11.0625 13.0625 11.5938 11H15.4062Z" fill="#0C3058"/>
        </svg>
        <button
          #languageToggleBtn
          type="button"
          class="lang-toggle"
          (click)="toggleLanguage()"
          [attr.aria-label]="chooseLanguageText"
          [attr.aria-haspopup]="'dialog'"
          [attr.aria-expanded]="isLanguageOpen ? 'true' : 'false'">
          <span class="current-lang">{{ currentLanguageLabel }}</span>
        </button>
      </div>

    </div>
  </div>

  <!--
    a11y: language-picker dialog.
    Audit (mot-route-planner-client, sidebar language popup):
      1. "יש להוסיף כפתור סגירה לפופאפ והקפיץ את הפוקוס לכפתור סגירה מיד בעת
         פתיחת פופאפ החלף שפה" — modal needs a real close (X) button and
         focus must jump to it the moment the dialog opens.
      2. "כותרת הפופאפ מוגדרת H3 יש לשנות את רמת הכותרת לh2" — heading must
         be h2, not h3.
    Implementation matches the parallel `mot-website-client` sidebar so the
    two products stay aligned: role=dialog + aria-modal=true + aria-labelledby
    pointing at the visible h2 title, dedicated `#languageModalCloseBtn` X
    button, header layout with a spacer to keep the title centered, and
    keyboard Escape handling via (keydown.escape) on the modal root.
  -->
  @if (isLanguageOpen) {
    <div
      class="language-modal"
      [class.open]="isLanguageOpen"
      role="dialog"
      aria-modal="true"
      aria-labelledby="language-modal-title"
      (keydown.escape)="onLanguageModalEscape($event)">
      <div class="modal-overlay" (click)="closeLanguageModal()"></div>
      <div class="modal-content">
        <div class="modal-handle"></div>
        <div class="modal-header">
          <span class="modal-header-spacer" aria-hidden="true"></span>
          <h2 id="language-modal-title" class="modal-title">{{ chooseLanguageText }}</h2>
          <button
            #languageModalCloseBtn
            type="button"
            class="modal-close-btn"
            (click)="closeLanguageModal()"
            [attr.aria-label]="closeText">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
        <div class="language-options" role="group">
          @for (lang of languages; track lang) {
            <button
              type="button"
              class="lang-option"
              [class.active]="lang.code === currentLanguage"
              [attr.aria-pressed]="lang.code === currentLanguage ? 'true' : 'false'"
              (click)="selectLanguage(lang.code)"
              >
              {{ lang.label }}
            </button>
          }
        </div>
      </div>
    </div>
  }

  <!-- Search Bar (same CMS search API as header; Enter / result → site in new tab) -->
  <div class="search-section" role="search">
    <div class="search-bar" [class.active]="isSearchActive">
      @if (!isSearchActive) {
        <button type="button" class="search-toggle" (click)="toggleSearch()" [attr.aria-label]="searchText">
          <svg class="search-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 6.5C13 7.9375 12.5312 9.28125 11.75 10.3438L15.1875 13.8125L15.9062 14.5L14.5 15.9375L13.7812 15.2188L10.3125 11.75C9.25 12.5625 7.90625 13 6.5 13C2.90625 13 0 10.0938 0 6.5C0 2.9375 2.90625 0 6.5 0C10.0625 0 13 2.9375 13 6.5ZM6.5 11C8.09375 11 9.5625 10.1562 10.375 8.75C11.1875 7.375 11.1875 5.65625 10.375 4.25C9.5625 2.875 8.09375 2 6.5 2C4.875 2 3.40625 2.875 2.59375 4.25C1.78125 5.65625 1.78125 7.375 2.59375 8.75C3.40625 10.1562 4.875 11 6.5 11Z" fill="#3D5979"/>
          </svg>
          <span class="search-placeholder">{{ searchText }}</span>
        </button>
      }

      @if (isSearchActive) {
        <div class="search-input-container">
          <svg class="search-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M13 6.5C13 7.9375 12.5312 9.28125 11.75 10.3438L15.1875 13.8125L15.9062 14.5L14.5 15.9375L13.7812 15.2188L10.3125 11.75C9.25 12.5625 7.90625 13 6.5 13C2.90625 13 0 10.0938 0 6.5C0 2.9375 2.90625 0 6.5 0C10.0625 0 13 2.9375 13 6.5ZM6.5 11C8.09375 11 9.5625 10.1562 10.375 8.75C11.1875 7.375 11.1875 5.65625 10.375 4.25C9.5625 2.875 8.09375 2 6.5 2C4.875 2 3.40625 2.875 2.59375 4.25C1.78125 5.65625 1.78125 7.375 2.59375 8.75C3.40625 10.1562 4.875 11 6.5 11Z" fill="#3D5979"/>
          </svg>
          <input
            type="text"
            class="search-input"
            [placeholder]="searchText"
            [attr.aria-label]="searchText"
            aria-autocomplete="list"
            autocomplete="off"
            [value]="searchQuery"
            (input)="onSearchInput($event)"
            (keydown.enter)="onSubmitSearch()"
            autofocus
            >
            <button type="button" class="exit-search-btn" (click)="exitSearch()" [title]="exitSearchText" [attr.aria-label]="exitSearchText">
              ✕
            </button>
          </div>
        }
      </div>
    </div>

    @if (isSearchActive && searchQuery.trim().length >= 2) {
      @if ((searchResults$ | async); as results) {
        @if (results.length > 0) {
          <!--
            a11y: search results render as native links (per audit). Each
            anchor carries the real target URL (built via searchResultHref),
            so screen readers announce them as "קישור", users get all native
            link affordances (middle-click, copy-link, open-in-new-tab), and
            visual styling is preserved through the existing .result-item
            class. The click handler only tears down our own UI; navigation
            is handled by the browser via target=_blank.
          -->
          <div class="search-results">
            @for (result of results; track result) {
              <a
                class="result-item"
                [href]="searchResultHref(result)"
                target="_blank"
                rel="noopener noreferrer"
                (click)="onSearchResultLinkClick()"
                >
                {{ result.title }}
              </a>
            }
          </div>
        }
        @if (results.length === 0) {
          <div class="no-results">
            <p>{{ noResultsText }} {{ searchQuery }}</p>
          </div>
        }
      }
    }

    <!-- Menu Items -->
    @if (!isSearchActive) {
      <ul class="menu-items">
        @for (item of menuItems; track item; let i = $index) {
          <li
            class="menu-item"
            [class.has-children]="item.children?.length"
            [class.active]="item.children?.length && isSubmenuOpen(i)"
            [attr.data-nav-index]="i">
            @if (item.children?.length) {
              <div
                role="button"
                tabindex="0"
                class="item-link"
                [attr.aria-expanded]="isSubmenuOpen(i) ? 'true' : 'false'"
                [attr.aria-controls]="submenuPanelId(i)"
                (click)="toggleSubmenu(i)"
                (keydown)="onSubmenuTriggerKeydown($event, i)">
                <span class="item-text">{{ item.title }}</span>
                <svg class="chevron-icon" [class.rotated]="isSubmenuOpen(i)" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                  <path d="M8.07422 9.4375L7.35547 8.71875L1.35547 2.71875L0.636719 2L2.07422 0.59375L2.76172 1.3125L8.07422 6.59375L13.3555 1.3125L14.0742 0.59375L15.4805 2L14.7617 2.71875L8.76172 8.71875L8.07422 9.4375Z" fill="#0C3058"/>
                </svg>
              </div>
              <ul
                class="submenu"
                [id]="submenuPanelId(i)"
                [hidden]="!isSubmenuOpen(i)">
                @for (child of item.children; track child) {
                  <li class="submenu-item">
                    <a
                      [href]="menuItemHref(child.url)"
                      target="_blank"
                      rel="noopener noreferrer"
                      (click)="onClose()">
                      {{ child.title }}
                    </a>
                  </li>
                }
              </ul>
            } @else {
              <a
                class="item-link"
                [href]="menuItemHref(item.url)"
                target="_blank"
                rel="noopener noreferrer"
                (click)="onClose()">
                <span class="item-text">{{ item.title }}</span>
              </a>
            }
          </li>
        }
      </ul>
    }

    <!--
      a11y: "הגשת פנייה" must be a link, not a button (audit) — clicking it
      navigates to an external URL (forms.gov.il), so semantically it's a
      link per ARIA / WCAG. Mirrors mot-website-client/sidebar implementation
      so screen-reader users hear "קישור" instead of "לחצן" and so the
      browser's native link behaviours (open-in-new-tab, copy link, etc.) work.
    -->
    <div class="bottom-buttons">
      <button type="button" class="contact-btn" (click)="onContactClick()">{{ contactUsText }}</button>
      <a
        class="complaint-btn"
        [href]="complaintUrl"
        target="_blank"
        rel="noopener noreferrer"
        (click)="onClose()">
        {{ makeComplaintText }}
      </a>
    </div>

    <!-- Floating Button -->
  </div>
</div>
